import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core";

import "../styles.css"

// const status = [
//     { value: 'ativo', label: 'ativo' },
//     { value: 'inativo', label: 'inativo' },
// ];

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
        console.log(event.target.id)
    };

    return (
        <>
            <div className="fundo">
                <div className="rowForm">
                    <div className="auto">
                        <TextField
                            margin="dense"
                            disabled
                            id="cor"
                            label="Cor"
                            value={props.values.cor}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="rowForm">
                    <div className="auto">
                        <TextField
                            margin="dense"
                            id="estado"
                            label="Estado"
                            value={props.values.estado}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="rowForm">
                    <div className="auto">
                        <TextField
                            multiline
                            margin="dense"
                            id="acidente"
                            label="Probabilidade de Acidente"
                            value={props.values.acidente}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="rowForm">
                    <div className="auto">
                        <TextField
                            multiline
                            margin="dense"
                            id="anomalias"
                            label="Presença de Anomalias"
                            value={props.values.anomalia}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="auto">
                        <TextField
                            multiline
                            margin="dense"
                            id="evento"
                            label="Evento Meteorológico e Capacidade de Descarga"
                            value={props.values.evento}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
